export default "/images/chevron-left.svg?a95f3e3e7c1cb3bbe43afaa323d1d855";